'use client';

import { c } from '../../../utils/tailwind-merge';
import { Separator } from '../../atoms/Separator/Separator';
import { PublisherInfo } from '../../molecules/PublisherInfo/PublisherInfo';
import { PublisherInfoTable } from '../../organisms/PublisherInfoTable/PublisherInfoTable';
import { PublisherOverview } from '../../organisms/PublisherOverview/PublisherOverview';
import { PublisherProfileTabs } from '../../organisms/PublisherProfileTabs/PublisherProfileTabs';
import { SocialMediaTable } from '../../organisms/SocialMediaTable/SocialMediaTable';
import { PublisherProfileTemplateProps } from './PublisherProfileTemplate.types';

export const PublisherProfileTemplate = ({
  tabs,
  overview,
  publisherInfo,
  publisherInfoTable,
  socialMedia,
  microcopy,
  className,
  renderPublisherAssets,
  onOpenCookieSettings,
}: PublisherProfileTemplateProps) => {
  return (
    <div className={className}>
      <section className="pb-4 lg:pb-16">
        <div
          className={c(
            'container flex flex-col gap-4 px-4 lg:gap-10 lg:px-8 xl:px-0'
          )}
        >
          {/* Main content area with sidebar */}
          <div className="flex flex-col-reverse gap-4 lg:flex-row lg:items-start lg:gap-6">
            {/* Left column - Overview on desktop, comes after sidebar content on mobile */}
            <div className="flex min-w-0 flex-col gap-6 lg:order-1 lg:flex-1">
              <PublisherOverview
                {...overview}
                onOpenCookieSettings={onOpenCookieSettings}
                className="order-2 lg:order-1"
              />
            </div>

            {/* Right column - Sidebar content */}
            <aside className="flex flex-col gap-4 lg:order-2 lg:w-[396px] lg:shrink-0 lg:gap-0">
              {/* Publisher Info - shows first on mobile, in sidebar on desktop */}
              <PublisherInfo
                size="big"
                microcopy={microcopy.publisherInfo}
                {...publisherInfo}
                className="mt-8 lg:mt-0"
              />
              <Separator className="my-2 lg:my-4" />
              <PublisherInfoTable
                {...publisherInfoTable}
                microcopy={microcopy.publisherInfoTable}
                rightColumnTextAlign="left"
                className="max-w-[710px] lg:max-w-none"
              />
              <SocialMediaTable
                microcopy={microcopy.socialMedia}
                {...socialMedia}
                className="max-w-[710px] lg:max-w-none"
              />
            </aside>
          </div>

          {/* Tabs - always at bottom */}
          <PublisherProfileTabs
            defaultValue="assets"
            {...tabs}
            microcopy={microcopy.tabs}
            renderPublisherAssets={renderPublisherAssets}
          />
        </div>
      </section>
    </div>
  );
};
